export interface AdjustmentDto {
  AdjustmentId: number;
  AdjustmentAmount: number;
  AdjustmentDate: Date;
  ApplyDate: Date;
  Descr: string;
  ProfileId: number;
  ReferenceNum: string;
  InvoiceNum: number;
  InvoiceLineItemId: number;
  PaymentId: number;
  UnappliedPaymentId: number;
  AdjustmentTypeId: number;
  AdjustmentType: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  GlAccount: string;
  Posted: boolean;
  DatePosted: Date;
  Batch_Creation: string;
  Batch_Posting: string;
  PostedBy: string;
}

export function initializedAdjustmentDto(partialDto?: Partial<AdjustmentDto>): AdjustmentDto {
  const today = new Date();
  const defaultDto = {
    DateCreated: today,
    DateChanged: today,
    DatePosted: today,
    AdjustmentDate: today,
    ApplyDate: today,
  } as AdjustmentDto;

  return { ...defaultDto, ...(partialDto ?? {}) };
}
